import React from 'react';
import PropTypes from 'prop-types';

const LocationTooFarInfoGraphic = props => (
    <svg
        width="180"
        height="55"
        viewBox="0 0 180 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <style>
                {`:root{
                --primaryColour: ${props.primaryColour};
                --secondaryColour: ${props.secondaryColour};
                }
                .location-pin-outline {
                fill: var(--primaryColour);
                }
                `}
            </style>
        </defs>

        <g clipPath="url(#clip0_1809_49019)">
            <path
                d="M10.7093 47.8912C16.6239 47.8912 21.4186 43.0965 21.4186 37.182C21.4186 31.2674 16.6239 26.4727 10.7093 26.4727C4.79471 26.4727 0 31.2674 0 37.182C0 43.0965 4.79471 47.8912 10.7093 47.8912Z"
                className="location-pin-outline"
                fillOpacity="0.21"
            />
            <path
                d="M10.9666 43.6364C14.3892 43.6364 17.1638 40.8619 17.1638 37.4393C17.1638 34.0167 14.3892 31.2422 10.9666 31.2422C7.54407 31.2422 4.76953 34.0167 4.76953 37.4393C4.76953 40.8619 7.54407 43.6364 10.9666 43.6364Z"
                fill="#1492FF"
            />
        </g>
        <path
            d="M26.3799 37.1836H118.642"
            stroke="url(#paint0_linear_1809_49019)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeDasharray="4 7"
        />
        <path
            d="M84.1167 43.3975C87.5494 43.3975 90.3321 40.6148 90.3321 37.1822C90.3321 33.7495 87.5494 30.9668 84.1167 30.9668C80.6841 30.9668 77.9014 33.7495 77.9014 37.1822C77.9014 40.6148 80.6841 43.3975 84.1167 43.3975Z"
            fill="#ED1C24"
        />
        <path
            d="M86.868 34.4287C86.7934 34.3541 86.7048 34.2949 86.6073 34.2545C86.5098 34.2141 86.4054 34.1934 86.2998 34.1934C86.1943 34.1934 86.0898 34.2141 85.9923 34.2545C85.8949 34.2949 85.8063 34.3541 85.7317 34.4287L84.1159 36.0445L82.4996 34.4287C82.425 34.3541 82.3364 34.2949 82.2389 34.2545C82.1414 34.2141 82.037 34.1934 81.9314 34.1934C81.8259 34.1934 81.7214 34.2141 81.624 34.2545C81.5265 34.2949 81.4379 34.3541 81.3633 34.4287C81.2887 34.5033 81.2295 34.5919 81.1891 34.6894C81.1487 34.7869 81.1279 34.8914 81.1279 34.9969C81.1279 35.1024 81.1487 35.2069 81.1891 35.3044C81.2295 35.4018 81.2887 35.4904 81.3633 35.565L82.9795 37.1808L81.3633 38.7971C81.2887 38.8717 81.2295 38.9603 81.1891 39.0578C81.1487 39.1553 81.1279 39.2597 81.1279 39.3653C81.1279 39.4708 81.1487 39.5753 81.1891 39.6728C81.2295 39.7702 81.2887 39.8588 81.3633 39.9334C81.4379 40.008 81.5265 40.0672 81.624 40.1076C81.7214 40.148 81.8259 40.1688 81.9314 40.1688C82.037 40.1688 82.1414 40.148 82.2389 40.1076C82.3364 40.0672 82.425 40.008 82.4996 39.9334L84.1159 38.3172L85.7317 39.9334C85.8063 40.008 85.8949 40.0672 85.9923 40.1076C86.0898 40.148 86.1943 40.1688 86.2998 40.1688C86.4054 40.1688 86.5098 40.148 86.6073 40.1076C86.7048 40.0672 86.7934 40.008 86.868 39.9334C86.9426 39.8588 87.0018 39.7702 87.0422 39.6728C87.0826 39.5753 87.1033 39.4708 87.1033 39.3653C87.1033 39.2597 87.0826 39.1553 87.0422 39.0578C87.0018 38.9603 86.9426 38.8717 86.868 38.7971L85.2522 37.1808L86.868 35.565C86.9426 35.4904 87.0018 35.4018 87.0422 35.3044C87.0826 35.2069 87.1033 35.1024 87.1033 34.9969C87.1033 34.8914 87.0826 34.7869 87.0422 34.6894C87.0018 34.5919 86.9426 34.5033 86.868 34.4287Z"
            fill="white"
        />
        <path
            d="M125.15 34.4472L145.918 22.3281C148.301 20.9371 151.234 20.873 153.676 22.1587L173.729 32.7147C176.484 34.1653 176.599 38.0694 173.933 39.6787L153.617 51.9416C151.222 53.3877 148.244 53.4769 145.767 52.177L125.307 41.4442C122.524 39.984 122.435 36.0314 125.15 34.4472Z"
            fill="#00A0DD"
            fillOpacity="0.18"
            stroke="#00A0DD"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M149.457 38.6593C150.273 38.6593 150.935 37.9975 150.935 37.1812C150.935 36.3649 150.273 35.7031 149.457 35.7031C148.64 35.7031 147.979 36.3649 147.979 37.1812C147.979 37.9975 148.64 38.6593 149.457 38.6593Z"
            fill="#FF0D32"
        />
        <path
            d="M162.76 14.2716C162.76 26.3521 149.457 26.9995 149.457 34.6213C149.457 26.9995 136.154 26.3521 136.154 14.2716C136.154 10.7435 137.556 7.35983 140.051 4.86506C142.545 2.3703 145.929 0.96875 149.457 0.96875C152.985 0.96875 156.369 2.3703 158.864 4.86506C161.358 7.35983 162.76 10.7435 162.76 14.2716Z"
            fill="#FF0D32"
        />
        <path
            d="M149.67 12.5632C149.367 12.5706 149.079 12.6944 148.864 12.9087C148.65 13.123 148.526 13.4116 148.519 13.7146C148.51 14.0297 148.626 14.3355 148.842 14.5656C149.058 14.7956 149.355 14.9314 149.67 14.9434C149.985 14.9314 150.283 14.7956 150.498 14.5656C150.714 14.3355 150.83 14.0297 150.822 13.7146C150.814 13.4116 150.69 13.123 150.476 12.9087C150.262 12.6944 149.973 12.5706 149.67 12.5632ZM149.67 11.1815C150.171 11.1815 150.661 11.33 151.077 11.6084C151.494 11.8867 151.819 12.2823 152.01 12.7452C152.202 13.2081 152.252 13.7174 152.155 14.2088C152.057 14.7001 151.816 15.1515 151.461 15.5058C151.107 15.86 150.656 16.1013 150.164 16.199C149.673 16.2968 149.164 16.2466 148.701 16.0549C148.238 15.8632 147.842 15.5385 147.564 15.1219C147.286 14.7053 147.137 14.2156 147.137 13.7146C147.143 13.0445 147.412 12.4036 147.885 11.9298C148.359 11.456 149 11.1872 149.67 11.1815ZM149.67 9.41565C147.904 9.41657 145.295 10.8747 145.295 13.4843C145.295 15.6333 148.135 19.0111 149.67 20.6231C151.206 19.0111 154.046 15.6333 154.046 13.5608C154.046 10.8747 151.436 9.41657 149.67 9.41657V9.41565ZM149.67 8.11133C152.049 8.11133 155.427 10.03 155.427 13.5617C155.427 16.7092 151.052 21.2375 150.207 22.0057C150.138 22.0785 150.054 22.1364 149.962 22.176C149.87 22.2156 149.77 22.236 149.67 22.236C149.569 22.236 149.47 22.2156 149.377 22.176C149.285 22.1364 149.202 22.0785 149.132 22.0057L148.979 21.8519C147.904 20.7769 143.913 16.5554 143.913 13.5617C143.913 9.9536 147.291 8.11133 149.67 8.11133Z"
            fill="white"
        />
        <defs>
            <linearGradient
                id="paint0_linear_1809_49019"
                x1="26.3799"
                y1="2.99808"
                x2="145.707"
                y2="2.99808"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00A0DD" />
                <stop offset="0.770833" stopColor="#00A0DD" stopOpacity="0.109375" />
                <stop offset="1" stopColor="#00A0DD" stopOpacity="0" />
            </linearGradient>
            <clipPath id="clip0_1809_49019">
                <rect
                    width="21.4186"
                    height="21.4186"
                    fill="white"
                    transform="translate(0 26.4727)"
                />
            </clipPath>
        </defs>
    </svg>
);

LocationTooFarInfoGraphic.propTypes = {
    primaryColour: PropTypes.string.isRequired,
    secondaryColour: PropTypes.string.isRequired,
};

export default LocationTooFarInfoGraphic;
